import React, { FC, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { RenderElement } from 'shared/hoc';
import { generateKey } from 'shared/functions';
import { MenuItems, SubnavigationItem } from 'shared/constants/menuItems';

import MenuItem from '../MenuItem/MenuItem';

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: ({ depthLevel }: any) => (depthLevel > 0 ? theme.spacing(depthLevel * 4) : 0),
  },
}));

type MenuModuleProps = {
  closeMenu: () => void;
  module: MenuItems | SubnavigationItem;
  depthLevel: number;
};

const MenuModule: FC<MenuModuleProps> = ({ closeMenu, module, depthLevel }) => {
  const [open, setOpen] = useState(true);
  const classes = useStyles({ depthLevel });

  const handleClick = () => setOpen(!open);

  return (
    <RenderElement licence={module.licence}>
      {depthLevel === 0 && <Divider />}
      <ListItem button onClick={handleClick} className={classes.nested}>
        <ListItemIcon>{module.icon}</ListItemIcon>
        <ListItemText primary={module.label} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div">
          {(module.subnavigation ?? [])
            .filter(item => !item.hidden)
            .map((item, index) =>
              item.subnavigation ? (
                <MenuModule
                  key={generateKey(index, item.label.toLowerCase())}
                  closeMenu={closeMenu}
                  module={item}
                  depthLevel={depthLevel + 1}
                />
              ) : (
                <RenderElement
                  key={generateKey(index, item.label.toLowerCase())}
                  permission={item.permission}
                  role={item.role}
                  condition={Boolean(item.to)}
                  shopPermissions={item.shopPermissions}
                >
                  <MenuItem
                    to={item.to ?? ''}
                    label={item.label}
                    icon={item.icon}
                    external={item.external}
                    closeMenu={closeMenu}
                    depthLevel={depthLevel}
                  />
                </RenderElement>
              ),
            )}
        </List>
      </Collapse>
    </RenderElement>
  );
};

export default MenuModule;
